import { attribute, clickable, fillable, value } from 'ember-cli-page-object';
import flashMessage from 'core/test-support/pages/components/flash-message';
import { isChecked } from 'vagrant/test-support/ecpo-utils';
export default (scope = '[data-test-create-box]', properties = {}) => ({
  scope,
  registry: value('[data-test-box-name] input:first'),
  fillInName: fillable('[data-test-box-name] input ~ input'),
  fillInDescription: fillable('textarea'),
  setToPrivate: clickable('input[name="visibility"][value="private"]'),
  setToPublic: clickable('input[name="visibility"][value="public"]'),
  isPrivate: isChecked('input[name="visibility"][value="private"]'),
  isPublic: isChecked('input[name="visibility"][value="public"]'),
  async setVisibility(val) {
    const opt = this.visibilityOptions.findOneBy('value', val);
    if (!opt) throw new Error(`No visibility option with value ${val}`);
    await opt.click();
  },
  submitButton: {
    scope: '.hds-button-set button[type="submit"]',
    isDisabled: attribute('disabled')
  },
  cancelButton: {
    scope: '.hds-button-set a.hds-button--color-secondary'
  },
  flash: {
    ...flashMessage,
    resetScope: true
  },
  ...properties
});